import { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
  InputBase,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UsePagesVisitReport } from "./UsePagesVisitReport";
import { UseMyPC } from "../../hooks/UseMyPC";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import DailyPagesVisitReport from "./DailyPagesVisitReport";
import CheckIcon from "@mui/icons-material/Check";
import useBreakpoints from "../../hooks/useBreakpoints";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CachedIcon from "@mui/icons-material/Cached";

export default function PagesVisitReport(props) {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetProductCache, GetArticleCache, GetPageVisitReport } =
    UsePagesVisitReport();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Visit", "Desc");
  const [pageVisitReport, setPageVisitReport] = useState();
  const [reportType, setReportType] = useState(1);
  const [searchState, setSearchState] = useState("");
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState("panel1");
  const { isSmall } = useBreakpoints();

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetPageVisitReport(search, reportType, myPc, true, (callback) => {
      setPageVisitReport(callback);
    });
  }, [myPc, reportType]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const columns = [
    {
      field: "id",
      width: 110,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
    },
    {
      field: "pageName",
      headerName: "محصول",
      width: 300,
      align: "center",

      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.pageName}
          </Typography>
        );
      },
    },

    {
      field: "visit",
      headerName: "بازدید",
      width: 120,
      align: "center",

      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.visit ? toMoney(cellValues.row.visit) : 0}
          </Typography>
        );
      },
    },
    {
      field: "totalVisit",
      headerName: "بازدید مجموع",
      width: 120,
      align: "center",
      hide: reportType == 1 ? false : true,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.totalVisit ? toMoney(cellValues.row.totalVisit) : 0}
          </Typography>
        );
      },
    },
    {
      field: "CachedIcon",
      headerName: "بروزرسانی",
      width: 80,
      sortable: false,
      align: "center",
      hide: reportType == 3 ? true : false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              if (reportType == 1) {
                GetProductCache(cellValues.row.id, () => {
                  setProgress(true);
                  GetPageVisitReport(
                    search,
                    reportType,
                    myPc,
                    false,
                    (callback) => {
                      setPageVisitReport(callback);
                    }
                  );
                });
              } else {
                GetArticleCache(cellValues.row.id, () => {
                  setProgress(true);
                  GetPageVisitReport(
                    search,
                    reportType,
                    myPc,
                    false,
                    (callback) => {
                      setPageVisitReport(callback);
                    }
                  );
                });
              }
            }}
          >
            <CachedIcon color="secondary" />
          </IconButton>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        // normargin: true,
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/pagevisit" }],
      }}
    >
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        style={{
          margin: isSmall ? 0 : "20px",
          marginBottom: isSmall && "20px",
          paddingBottom: "15px",
        }}
      >
        <AccordionSummary
          // onClick={() => props.setExpanded("panel1")}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FiberManualRecordIcon color="secondary" fontSize="small" />
            <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
              گزارش بازدید صفحات
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Button
              sx={{ width: "100px" }}
              color="secondary"
              startIcon={reportType == 1 && <CheckIcon />}
              variant={reportType == 1 ? "contained" : "outlined"}
              onClick={() => {
                setReportType(1);
              }}
            >
              محصول
            </Button>
            <Button
              sx={{
                width: "100px",
                mx: 2,
              }}
              color="secondary"
              startIcon={reportType == 2 && <CheckIcon />}
              variant={reportType == 2 ? "contained" : "outlined"}
              onClick={() => {
                setReportType(2);
              }}
            >
              مقاله
            </Button>
            <Button
              sx={{
                width: "100px",
              }}
              startIcon={reportType == 3 && <CheckIcon />}
              color="secondary"
              variant={reportType == 3 ? "contained" : "outlined"}
              onClick={() => {
                setReportType(3);
              }}
            >
              لندینگ
            </Button>
          </Box>
          {pageVisitReport ? (
            <Box sx={{ height: "30rem" }}>
              <DataGrid
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                pageSize={
                  pageVisitReport && pageVisitReport.pageCondition
                    ? pageVisitReport.pageCondition.pageCount
                    : 1
                }
                rows={pageVisitReport ? pageVisitReport.items : []}
                paginationMode="server"
                page={
                  pageVisitReport && pageVisitReport.pageCondition
                    ? pageVisitReport.pageCondition.page - 1
                    : 1
                }
                onPageChange={(page) => {
                  updatePage(page + 1);
                }}
                rowCount={
                  pageVisitReport && pageVisitReport.pageCondition
                    ? pageVisitReport.pageCondition.totalItemCount
                    : 1
                }
                enableRangeSelection={true}
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    scrollTo: myPc.scrollTo,
                    isLtr: true,
                    nofab: true,
                    rowCount:
                      pageVisitReport && pageVisitReport.pageCondition
                        ? pageVisitReport.pageCondition.totalItemCount
                        : "",
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: deCapitalizeFirstLetter(myPc.sortColumn),
                        sort: deCapitalizeFirstLetter(myPc.sortOrder),
                      },
                    ],
                  },
                  pagination: {
                    page: myPc.page,
                  },
                }}
                onSortModelChange={(model) => {
                  updateSort(
                    model[0].field,
                    model[0].sort == "asc" ? "asc" : "desc"
                  );
                }}
                sortingOrder={["desc", "asc"]}
                sortingMode="server"
              />
            </Box>
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </AccordionDetails>
      </Accordion>
      <DailyPagesVisitReport expanded={expanded} setExpanded={setExpanded} />
    </Detail>
  );
}
